import {Component, QueryList, ViewChildren} from "@angular/core";
import {MachineManagerService} from "../../../../services/machine-manager.service";
import {PipelineState, RealtimeState} from "../../../../model/machine.model";
import {ProcessReport} from "../../../../model/reports.model";
import {NgbdSortableHeader} from "../../../results/cases/list/list.component";

@Component({
  selector: "machine-batches",
  templateUrl: "./batches.component.html",
  styleUrls: ["./batches.component.css"]
})
export class BatchesComponent {

  result: PipelineState[] = [];

  page: number = 1;
  pageSize: number = 5;

  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;

  constructor(
    private machineManager: MachineManagerService
  ) {
    const results$ = this.machineManager.pipelinesSubject.asObservable();
    results$.subscribe(results => {
      this.page = 1;
      this.paginate();
    });
  }

  get all() {
    return this.machineManager.machine.pipelines;
  }

  run(ps: PipelineState) {
    let batch = this.machineManager?.machine?.batch ?? "";
    this.machineManager.pipelineRun(batch, ps);
  }

  cancel(rs: PipelineState) {
    let batch = this.machineManager?.machine?.batch ?? "";
    this.machineManager.pipelineCancel(rs.channel);
  }

  statusClass(report: ProcessReport) {
    if (report.status == "SUCCESS") {
      return "success";
    } else if (report.status == "RUNNING") {
      return "running";
    } else if (report.status == "ERRORS") {
      return "errors";
    } else if (report.status == "NEW") {
      return "new";
    } else if (report.status == "DONE") {
      return "done";
    }
    return "disabled";
  }

  paginate() {
    this.result = this.machineManager.pipelinesSubject.value.map((one, i) => ({ id: i + 1, ...one })).slice(
      (this.page - 1) * this.pageSize,
      (this.page - 1) * this.pageSize + this.pageSize,
    );
  }
}
